import React from 'react';
import { Box, Button, Typography, useTheme, useMediaQuery } from '@mui/material';
import { ArrowBack as ArrowBackIcon } from '@mui/icons-material';
import { useTranslation } from '../../../hooks/useTranslation';

const ClientSignUpActions = ({ onBack, onSubmit, loading }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const { t } = useTranslation();

  return (
    <>
      {/* Action Buttons */}
      <Box 
        sx={{
          display: 'flex',
          gap: 2,
          flexDirection: { xs: 'column', sm: 'row' },
          justifyContent: { xs: 'stretch', sm: 'space-between' },
          alignItems: { xs: 'stretch', sm: 'center' },
          mt: 'auto'
        }}
      >
        <Button
          variant={isMobile ? "outlined" : "text"}
          onClick={onBack}
          startIcon={<ArrowBackIcon />}
          sx={{
            order: { xs: 2, sm: 1 },
            flex: { xs: 1, sm: 'none' },
            py: { xs: 1.5, sm: 1 },
            ...(isMobile ? {
              borderColor: 'rgba(255,255,255,0.3)',
              color: 'rgba(255,255,255,0.8)',
              '&:hover': {
                borderColor: '#f5f5dc',
                backgroundColor: 'rgba(245,245,220,0.1)',
                color: '#f5f5dc'
              }
            } : {
              color: 'rgba(255,255,255,0.7)',
              '&:hover': {
                backgroundColor: 'rgba(255,255,255,0.1)',
                color: '#f5f5dc'
              }
            })
          }}
        >
          {t('common.back')}
        </Button>
        
        <Button
          variant="contained"
          onClick={onSubmit}
          disabled={loading}
          sx={{ 
            order: { xs: 1, sm: 2 },
            flex: { xs: 2, sm: 'none' },
            px: { xs: 3, sm: 4 },
            py: { xs: 1.5, sm: 1.5 },
            borderRadius: { xs: 2, sm: 3 },
            fontWeight: 600,
            fontSize: { xs: '0.9rem', sm: '1rem' },
            background: 'linear-gradient(135deg, #f5f5dc 0%, #e8e8c8 100%)',
            color: '#212121',
            boxShadow: '0 8px 25px rgba(245, 245, 220, 0.3)',
            '&:hover': {
              background: 'linear-gradient(135deg, #e8e8c8 0%, #dcdcb8 100%)',
              transform: { xs: 'none', sm: 'translateY(-2px)' },
              boxShadow: '0 12px 35px rgba(245, 245, 220, 0.4)'
            },
            '&:disabled': {
              background: 'rgba(255,255,255,0.1)',
              color: 'rgba(255,255,255,0.3)'
            }
          }}
        >
          {loading ? t('auth.creating') : t('auth.createMyAccount')}
        </Button>
      </Box>

      {/* Legal Links */}
      <Box textAlign="center" mt={{ xs: 3, md: 4 }}>
        <Typography 
          variant={isMobile ? "caption" : "body2"} 
          sx={{ 
            lineHeight: 1.6, 
            color: 'rgba(255,255,255,0.7)',
            fontSize: { xs: '0.75rem', md: '0.875rem' }
          }}
        >
          {t('auth.byCreatingAccount')}{' '}
          <Box 
            component="a" 
            href="/terms"
            target="_blank"
            rel="noopener noreferrer"
            sx={{ 
              color: '#f5f5dc', 
              fontWeight: 600, 
              textDecoration: 'none',
              '&:hover': {
                textDecoration: 'underline'
              }
            }}
          >
            {t('footer.terms')}
          </Box>
          {' '}{t('auth.andOur')}{' '}
          <Box 
            component="a" 
            href="/privacy"
            target="_blank"
            rel="noopener noreferrer"
            sx={{ 
              color: '#f5f5dc', 
              fontWeight: 600, 
              textDecoration: 'none',
              '&:hover': {
                textDecoration: 'underline'
              }
            }}
          >
            {t('footer.privacy')}
          </Box>
        </Typography>
      </Box>
    </>
  );
};

export default ClientSignUpActions;